import buildComponent from './utils/build-component';

export default (nameSpace) => buildComponent({
  nameSpace,
  initFunction: ($el, params) => {
    //
    // Methods
    //

    function hide() {
      $el.classList.add(`${nameSpace}--is-hidden`);
    }

    function show() {
      $el.classList.remove(`${nameSpace}--is-hidden`);
    }

    //
    // Public API
    //

    return {
      hide,
      show,
    };
  },
});



// WEBPACK FOOTER //
// ./src/scripts/page-loader.js